import { GetUploadDocumentResponse } from "../../types/Document";
import { safeGET } from "./SafeClient";

export async function getUpload(uploadId: number, abort?: any): Promise<GetUploadDocumentResponse> {
    return safeGET(`/api/orderform/upload/${uploadId}`, abort);
}
